import router from '@/router'

router.addRoute({
  path: '/hotel/sadmin/table',
  name: 'Table',
  component: () => import('./View.vue')
})
